import { VocalLib, type MelodyTrainerMode } from '@tunasong/music-lib'

/**
 * A take's pitch score, by how it was captured.
 *
 * - **MIDI is scored strictly.** A keyboard has every octave, so an octave-out performance is wrong
 *   notes rather than the range accommodation §5.7's transpose rule gives a voice or a mic'd instrument
 *   (Bowie, 2026-09-09). A keyboard also sends every repeated key, so nothing is forgiven.
 * - **Through a microphone,** a held note is heard once where the melody repeats it, so the repeats it
 *   absorbed are not counted as missed (Bowie, #2440).
 *
 * @param reference the practice melody's notes, in order: the scored reference is their pitches
 * @param bpm the practice melody's tempo, to tell a held note from a short one (Bowie, #2440)
 */
export const scoreTake = (
  sung: VocalLib.SungNote[],
  reference: VocalLib.ReferenceNote[],
  mode: MelodyTrainerMode,
  bpm: number
): VocalLib.PhraseScore | null => {
  const midis = reference.map(note => note.midi)
  if (mode === 'midi') {
    return VocalLib.scorePhrase(sung, midis, { octaveRule: 'strict' })
  }
  const score = VocalLib.scorePhrase(sung, midis, { octaveRule: 'transpose' })
  return score && VocalLib.forgiveAbsorbedRepeats(score, reference, sung, bpm)
}
